export default function reducer(state={
    transactions: null,
    fetching: false,
    fetched: false,
    error: null,
    userEmpresas: null,
    selectedEmpresa:null,
    currentSettings:null,
    lastItem: null,
    saved: null,
    saldo: null,
    saldoInicio: null
}, action){
    switch (action.type) {
        case "FETCH_TRANSACTIONS":
            return {...state, fetching: true}
        case "FETCH_TRANSACTIONS_REJECTED":
            return {...state, fetching:false, error: action.payload}
        case "FETCH_TRANSACTIONS_FULFILLED":
            return {
                ...state,
                fetching: false,
                fetched: true,
                transactions: action.payload,
            }
        case "FETCH_SALDO_INICIO":
            return {...state, fetching: true}
        case "FETCH_SALDO_INICIO_REJECTED":
            return {...state, fetching:false, error: action.payload}
        case "FETCH_SALDO_INICIO_FULFILLED":
            return {
                ...state,
                fetching: false,
                fetched: true,
                saldoInicio: action.payload,
            }        
        case "GET_ITEM":
            return {...state, fetching: true}
        case "GET_ITEM_REJECTED":
            return {...state, fetching:false, error: action.payload}
        case "GET_ITEM_FULFILLED":
            return {
                ...state,
                fetching: false,
                lastItem: action.payload
            }
        case "EDIT_ITEM":
            return {...state, fetching: true}
        case "EDIT_ITEM_REJECTED":
            return {...state, fetching:false, error: action.payload}
        case "EDIT_ITEM_FULFILLED":
            return {
                ...state,
                fetching: false,
                saved: true,
            }
        case "ADD_ITEM":
            return {...state, fetching: true}
        case "ADD_ITEM_REJECTED":
            return {...state, fetching:false, error: action.payload}
        case "ADD_ITEM_FULFILLED":
            return {
                ...state,
                fetching: false,
                saved: true,
            }
        case "GET_SALDO_GERAL":
            return {...state, fetching: true}
        case "GET_SALDO_GERAL_REJECTED":
            return {...state, fetching:false, error: action.payload}
        case "GET_SALDO_GERAL_FULFILLED":
            return {
                ...state,
                fetching: false,
                saldo: action.payload
            }             
        case "DELETE_ITEM":
            return {...state, fetching: true}
        case "DELETE_ITEM_REJECTED":
            return {...state, fetching:false, error: action.payload}
        case "DELETE_ITEM_FULFILLED":
            return {
                ...state,
                fetching: false,
            }                                  
        case "RESET":
            return{...state,
                transactions: null,
                fetching: false,
                fetched: false,
                error: null,
                userEmpresas: null,
                selectedEmpresa:null }
        case "RESET_ERRORS":
                return{...state,
                    fetched: false,
                    saved: null,
                    error: null}                                            
        default:   
        return state
    }
}





// WEBPACK FOOTER //
// ./src/reducers/transactions.js